import suiteService from 'qreventos-suite/services';
import invitacionService from 'qreventos-suite/invitaciones';

class SuiteConfig {
  evento: number = 916;
  token: string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4SSt4d09sd2VOSjg4WkF5WUZtTS9rTT0=';
  clientId: string = '1f49abc2-b24f-cfdd-be1c-f04411814eb3-916';

  public constructor() {
    suiteService.clientId = this.clientId;
    suiteService.token = this.token;
    invitacionService.clientId = this.clientId;
    invitacionService.token = this.token;
  }
}

export default new SuiteConfig();